import { instance } from "../../config/intercepter";

// GET Requests

export const getServiceBookingInitializeFieldsFn = async () => {
  const response = await instance.get(`api/servicebooking/create`);
  return response.data;
};

export const getServiceBookingUndoStepFn = async ({serviceFlowId,payload}) => {
  const response = await instance.post(`api/servicebooking/${serviceFlowId}/undo`, payload);
  return response.data;
};

export const getServiceBookingCurrentStepFn = async (serviceFlowId) => {
  const response = await instance.get(
    `api/servicebooking/${serviceFlowId}/create`
  );
  return response.data;
};

export const getServiceBookingListingFn = async (plateno) => {
  const response = await instance.get(`api/servicebooking?plateno=${plateno}`);
  return response.data;
};

export const getServiceBookingShowSummaryFn = async (serviceFlowId) => {
  const response = await instance.get(`api/servicebooking/${serviceFlowId}`);
  return response.data;
};

export const getServiceBookingCancelFn = async ({serviceFlowId,payload}) => {
  const response = await instance.post(`api/servicebooking/${serviceFlowId}/cancel`, payload);
  return response.data;
};

export const getServiceBookingAccidentReportDownloadFn = async () => {
  const response = await instance.get(`api/localfile/Accident_Report_GR.pdf`, {
    responseType: 'arraybuffer'
  });
  return response.data;
};

// POST Requests

export const serviceBookingEntryBookingStepFn = async ({payload}) => {
  // const mockPayload = {
  //   plateno: "XZZ4295",
  //   mileage: 30000,
  //   serviceLightIndicator: false,
  // };
  const response = await instance.post(`api/servicebooking`, payload);
  return response.data;
};

export const serviceBookingWorkSelectionFn = async ({
  serviceFlowId,
  payload,
}) => {
  // const mockPayload = {
  //   // workSelection: ["standarizedService", "tyreChange", "bodyWork"],
  //   // workSelection: ["standarizedService", "tyreChange"],
  //   // workSelection: ["standarizedService", "bodyWork"],
  //   // workSelection: ["tyreChange", "bodyWork"],
  //   // workSelection: ["standarizedService"],
  //   // workSelection: ["bodyWork"],
  //   // workSelection: ["tyreChange"],
  //   // workSelection: ["standarizedService", "tyreChange"],
  // };
  const response = await instance.post(
    `api/servicebooking/${serviceFlowId}/workSelection`,
    payload
  );
  return response.data;
};

export const serviceBookingPickUpAddressFn = async ({ serviceFlowId, payload }) => {
  // const mockPayload = {
  //   // pickupDeliveryAddress: "Σκρα 22, Καλλιθέα 17673 Ελλάδα",
  //   // pickupDeliveryAddress: "Ολύμπου 93, Θεσσαλονίκη, Ελλάδα",
  //   // pickupDeliveryAddress: "street no, Ηράκλειο, Ελλάδα",
  //   // pickupDeliveryAddress: "street no, Πάτρα, Ελλάδα",
  // };
  const response = await instance.post(
    `api/servicebooking/${serviceFlowId}/pickupDeliveryAddress`,
    payload
  );
  return response.data;
};

export const serviceBookingLocationFn = async ({ serviceFlowId, payload }) => {
  // const mockPayload = {
  //   // location: "Καλλιθέα",
  //   // location: "Θεσσαλονίκη",
  //   // location: "Ηράκλειο, Kρήτη",
  //   // location: "Πάτρα",
  // };
  const response = await instance.post(
    `api/servicebooking/${serviceFlowId}/location`,
    payload
  );
  return response.data;
};

export const serviceBookingOptionSelectionFn = async ({
  serviceFlowId,
  payload,
}) => {
  // const mockPayload = {
  //   // optionSelection: "PickupAuthorized",
  //   // optionSelection: "AuthorizedMap",
  //   // optionSelection: "CRMForm",
  //   // optionSelection: "FirstAvailableAvis",
  //   // optionSelection: "NearestAvis",
  //   // optionSelection: "PickupAvis",
  // };
  const response = await instance.post(
    `api/servicebooking/${serviceFlowId}/optionSelection`,
    payload
  );
  return response.data;
};

export const serviceBookingBookingFn = async ({ serviceFlowId, payload }) => {
  // const mockPayload = {
  //   bookingSelect: "ΜΕΤΑΜΟΡΦΩΣΗ",
  //   bookingCalendar: "2025-10-09T07:00:00Z",
  // };
  const response = await instance.post(
    `api/servicebooking/${serviceFlowId}/booking`,
    payload
  );
  return response.data;
};

export const serviceBookingTyreChangeFn = async ({
  serviceFlowId,
  payload,
}) => {
  // const mockPayload = {
  //   frontTyreWidth: 235,
  //   frontTyreHeight: 55,
  //   frontTyreDiameter: 16,
  //   tyreRunFlat: true,
  //   rearSameAsFront: false,
  //   rearTyreWidth: 205,
  //   rearTyreHeight: 65,
  //   rearTyreDiameter: 17,
  // };
  const response = await instance.post(
    `api/servicebooking/${serviceFlowId}/tyreChange`,
    payload
  );
  return response.data;
};

export const serviceBookingBodyWorkFn = async ({ serviceFlowId, payload }) => {
  // const mockPayload = {
  //   bodyWork: 'Fix the front bumper',
  //   //form data input
  //   bodyWorkPhotos_1: 'file 1',
  //   bodyWorkPhotos_2: 'File 2',
  //   bodyWorkPhotos_3: 'file 3',
  //   accidentReport:'file.pdf'
  // };
  const response = await instance.post(
    `api/servicebooking/${serviceFlowId}/bodyWork`,
    payload,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

export const serviceBookingAdditionalCommentsFn = async ({
  serviceFlowId,
  payload,
}) => {
  // const mockPayload = {
  //   additionalComments: "comment",
  // };
  const response = await instance.post(
    `api/servicebooking/${serviceFlowId}/additionalComments`,
    payload
  );
  return response.data;
};

export const serviceBookingCRMFormFn = async ({ serviceFlowId, payload }) => {
  // const mockPayload = {
  //   preferredTimeslots: ["2025-10-13T11:00:00Z", "2025-10-14T08:00:00Z"],
  //   preferredGarage: "f277cb77-b671-ef11-a670-6045bd905f5a",
  // };
  const response = await instance.post(
    `api/servicebooking/${serviceFlowId}/formForCRM`,
    payload
  );
  return response.data;
};
